@if (serviceaftale) {
  <div>
    <div class="data">
      @if (serviceaftale.serviceAbonnement.isTilkaldsabonnement) {
        <div>
          <div class="data__lbl">Ingen abonnement</div>
        </div>
      }
      @if (!serviceaftale.serviceAbonnement.isTilkaldsabonnement) {
        <div>
          <div class="data__lbl">Abonnement</div>
          <div class="data__val">
            {{ serviceaftale?.serviceAbonnement?.description }}
          </div>
        </div>
      }
    </div>
    @if (!serviceaftale.serviceAbonnement.isTilkaldsabonnement) {
      <div class="data">
        <div class="data__lbl">Tilvalg</div>
        <div class="data__val">
          @for (tilvalg of serviceaftale.tilvalg; track tilvalg) {
            <div>{{ tilvalg.name }}</div>
          }
          @if (!serviceaftale.tilvalg || serviceaftale.tilvalg.length == 0) {
            <div>Ingen tilvalg til denne aftale</div>
          }
        </div>
      </div>
    }
    <div class="data">
      <div class="data__lbl">Opsagt pr.</div>
      <div class="data__val">{{ endDate | date: 'dd.MM.yyyy' }}</div>
    </div>
    <div class="data">
      @if (!serviceaftale.serviceAbonnement.isTilkaldsabonnement) {
        <div>
          <div class="data__lbl">Sidste serviceperiode</div>
          <div class="data__val">
            {{ $safeNavigationMigration(sidsteServiceinterval?.startDate) | date: 'dd.MM.yyyy' }} -
            {{ $safeNavigationMigration(sidsteServiceinterval?.endDate) | date: 'dd.MM.yyyy' }}
          </div>
        </div>
      }
    </div>
    <div class="data">
      @if (!serviceaftale.serviceAbonnement.isTilkaldsabonnement) {
        <div>
          <div class="data__lbl">Eftersyn</div>
          <app-eftersyn-status
            [eftersynState]="$safeNavigationMigration(sidsteServiceinterval?.eftersynState?.eftersynState)"
            [serviceordreNo]="$safeNavigationMigration(sidsteServiceinterval?.eftersynState.eftersyn?.serviceordreNo)"
          ></app-eftersyn-status>
        </div>
      }
    </div>
    <div class="data">
      @if (!serviceaftale.serviceAbonnement.isTilkaldsabonnement) {
        <div>
          <div class="data__lbl">Opkrævning status</div>
          <app-opkraevnings-status [opkraevningState]="$safeNavigationMigration(sidsteServiceinterval?.opkraevningState)"></app-opkraevnings-status>
        </div>
      }
    </div>
    @if (!serviceaftale.serviceAbonnement.isTilkaldsabonnement) {
      <div class="data">
        <div class="data__lbl">Tilvalg</div>
        <div class="data__val">
          @for (tilvalg of serviceaftale.tilvalg; track tilvalg) {
            <div>{{ tilvalg.name }}</div>
          }
          @if (!serviceaftale.tilvalg || serviceaftale.tilvalg.length == 0) {
            <div>Ingen tilvalg til denne aftale</div>
          }
        </div>
      </div>
    }
    @if (!serviceaftale.serviceAbonnement.isTilkaldsabonnement) {
      <div class="data">
        <div class="data__lbl">Opkrævning</div>
        <div class="data__val">
          <div class="icon-with-text">
            <span
              [class.cursor-help]="serviceaftale.opkraevningsinterval != serviceaftale.serviceAbonnement.opkraevningInterval"
              [matTooltipDisabled]="serviceaftale.opkraevningsinterval == serviceaftale.serviceAbonnement.opkraevningInterval"
          [matTooltip]="
            'Opkrævningsintervallet afviger fra det normale på ' +
            serviceaftale.serviceAbonnement.opkraevningInterval +
            ' måneder via abonnementet'
          "
              >
              Hver
              @if (!serviceaftale.opkraevningsinterval) {
                <span>
                  {{ serviceaftale.serviceAbonnement.opkraevningInterval }}
                </span>
              }
              @if (serviceaftale.opkraevningsinterval) {
                <span>{{ serviceaftale.opkraevningsinterval }}.</span>
              }
              mdr.&nbsp;
            </span>
          </div>
        </div>
      </div>
    }
  </div>
}
